/**
 * @generated SignedSource<<b15ad4483c2cafe6883ad764eca86c23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpUserLink_ethereumAddress$data = {
  readonly address: string | null;
  readonly ensDomain: string | null;
  readonly isDibsAddress: boolean | null;
  readonly publicProfile: {
    readonly profileName: string | null;
  } | null;
  readonly publicProfileUrl: string | null;
  readonly " $fragmentType": "NftPdpUserLink_ethereumAddress";
};
export type NftPdpUserLink_ethereumAddress$key = {
  readonly " $data"?: NftPdpUserLink_ethereumAddress$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpUserLink_ethereumAddress",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicProfileUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDibsAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ensDomain",
      "storageKey": null
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "7a36c654e076b2271308486891f2eb90";

export default node;
